// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptRfidInviteData, AcceptRfidInviteErrors, AcceptRfidInviteResponses, GetRfidInviteData, GetRfidInviteErrors, GetRfidInviteResponses, GetUsersForOrganizationData, GetUsersForOrganizationErrors, GetUsersForOrganizationResponses, GetUsersForOrganizationsData, GetUsersForOrganizationsErrors, GetUsersForOrganizationsResponses, PutUserForOrganizationData, PutUserForOrganizationErrors, PutUserForOrganizationResponses, PutUserForOrganizationsData, PutUserForOrganizationsErrors, PutUserForOrganizationsResponses, RejectRfidInviteData, RejectRfidInviteErrors, RejectRfidInviteResponses, RemoveUserFromOrganizationData, RemoveUserFromOrganizationErrors, RemoveUserFromOrganizationResponses, RemoveUserFromOrganizationsData, RemoveUserFromOrganizationsErrors, RemoveUserFromOrganizationsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * List users for multiple organizations
 *
 * Aggregates users across all charge systems connected to the organizations identified by organizationIds
 */
export const getUsersForOrganizations = <ThrowOnError extends boolean = false>(options: Options<GetUsersForOrganizationsData, ThrowOnError>): RequestResult<GetUsersForOrganizationsResponses, GetUsersForOrganizationsErrors, ThrowOnError> => (options.client ?? client).post<GetUsersForOrganizationsResponses, GetUsersForOrganizationsErrors, ThrowOnError>({
    url: '/organizations/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create or replace a user within multiple organization scopes
 *
 * Upserts the user identified by phone number and adds the user to all charge systems connected to the organizations identified by organizationIds
 */
export const putUserForOrganizations = <ThrowOnError extends boolean = false>(options: Options<PutUserForOrganizationsData, ThrowOnError>): RequestResult<PutUserForOrganizationsResponses, PutUserForOrganizationsErrors, ThrowOnError> => (options.client ?? client).post<PutUserForOrganizationsResponses, PutUserForOrganizationsErrors, ThrowOnError>({
    url: '/organizations/users/add',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a user from multiple organizations
 *
 * Removes charge system access for all charge systems connected to the organizations identified by organizationIds
 */
export const removeUserFromOrganizations = <ThrowOnError extends boolean = false>(options: Options<RemoveUserFromOrganizationsData, ThrowOnError>): RequestResult<RemoveUserFromOrganizationsResponses, RemoveUserFromOrganizationsErrors, ThrowOnError> => (options.client ?? client).post<RemoveUserFromOrganizationsResponses, RemoveUserFromOrganizationsErrors, ThrowOnError>({
    url: '/organizations/users/remove',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List users for an organization
 *
 * Aggregates users across all charge systems connected to the organization identified by organizationId
 */
export const getUsersForOrganization = <ThrowOnError extends boolean = false>(options: Options<GetUsersForOrganizationData, ThrowOnError>): RequestResult<GetUsersForOrganizationResponses, GetUsersForOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetUsersForOrganizationResponses, GetUsersForOrganizationErrors, ThrowOnError>({ url: '/organizations/{organizationId}/users', ...options });

/**
 * Removes a user from an organization
 *
 * Removes charge system access for all charge systems connected to the organization identified by organizationId
 */
export const removeUserFromOrganization = <ThrowOnError extends boolean = false>(options: Options<RemoveUserFromOrganizationData, ThrowOnError>): RequestResult<RemoveUserFromOrganizationResponses, RemoveUserFromOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<RemoveUserFromOrganizationResponses, RemoveUserFromOrganizationErrors, ThrowOnError>({ url: '/organizations/{organizationId}/users/{phoneNumber}', ...options });

/**
 * Create or replace a user within an organization scope
 *
 * Upserts the user identified by phone number and adds the user to all charge systems connected to the organization identified by organizationId
 */
export const putUserForOrganization = <ThrowOnError extends boolean = false>(options: Options<PutUserForOrganizationData, ThrowOnError>): RequestResult<PutUserForOrganizationResponses, PutUserForOrganizationErrors, ThrowOnError> => (options.client ?? client).put<PutUserForOrganizationResponses, PutUserForOrganizationErrors, ThrowOnError>({
    url: '/organizations/{organizationId}/users/{phoneNumber}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an RFID invite by token
 *
 * Returns the pending RFID claim invitation details for a magic-link token
 */
export const getRfidInvite = <ThrowOnError extends boolean = false>(options: Options<GetRfidInviteData, ThrowOnError>): RequestResult<GetRfidInviteResponses, GetRfidInviteErrors, ThrowOnError> => (options.client ?? client).get<GetRfidInviteResponses, GetRfidInviteErrors, ThrowOnError>({ url: '/public/rfid-invites/{token}', ...options });

/**
 * Accept an RFID invite
 *
 * Accepts the pending RFID claim invitation identified by the magic-link token
 */
export const acceptRfidInvite = <ThrowOnError extends boolean = false>(options: Options<AcceptRfidInviteData, ThrowOnError>): RequestResult<AcceptRfidInviteResponses, AcceptRfidInviteErrors, ThrowOnError> => (options.client ?? client).post<AcceptRfidInviteResponses, AcceptRfidInviteErrors, ThrowOnError>({ url: '/public/rfid-invites/{token}/accept', ...options });

/**
 * Reject an RFID invite
 *
 * Rejects the pending RFID claim invitation identified by the magic-link token
 */
export const rejectRfidInvite = <ThrowOnError extends boolean = false>(options: Options<RejectRfidInviteData, ThrowOnError>): RequestResult<RejectRfidInviteResponses, RejectRfidInviteErrors, ThrowOnError> => (options.client ?? client).post<RejectRfidInviteResponses, RejectRfidInviteErrors, ThrowOnError>({ url: '/public/rfid-invites/{token}/reject', ...options });
